import { Navigate, Route } from 'react-router-dom';

/* ===========================================================================
 * THE PATHS THE OPERATIONS MERGE RETIRED.
 *
 * "Live attendance", "Site & camp board" and "Live site board" answered
 * overlapping halves of one question and disagreed in the gaps, so they became
 * one screen with four views (see `OPERATIONS` in navItems.ts). These five
 * addresses are what people had bookmarked, mailed each other and saved into
 * scheduled reports before that, and they still resolve — each landing on the
 * VIEW that replaced it rather than on a dead end.
 *
 * They live here rather than inline in `App.tsx` because they are one group
 * with one reason to change (the day the merge's compatibility window closes,
 * all five go together), and `App.tsx` is long-standing size debt behind a
 * ratchet that only lets it shrink.
 *
 * A FRAGMENT, not a component. `<Routes>` walks `<React.Fragment>` children
 * looking for `<Route>` elements, but it rejects a component that RETURNS
 * them — so this is an element to splice in, `{OPERATIONS_RETIRED_PATHS}`,
 * rather than `<OperationsRetiredPaths />`.
 * ======================================================================== */
export const OPERATIONS_RETIRED_PATHS = (
  <>
    <Route
      path="live"
      element={<Navigate to="/operations?view=people" replace />}
    />
    <Route
      path="live/map"
      element={<Navigate to="/operations?view=map&pins=people" replace />}
    />
    <Route
      path="worksites/allocations"
      element={<Navigate to="/operations?view=map" replace />}
    />
    <Route
      path="worksites/board"
      element={<Navigate to="/operations?view=sites" replace />}
    />
    <Route
      path="worksites/live-board"
      element={<Navigate to="/operations?view=map" replace />}
    />
  </>
);
